import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgIcon } from '@ng-icons/core';
import { QpxIcon } from '@quipex/shared/ui';
import type { CapabilityRow } from './models';

@Component({
    selector: 'qpx-publish-capabilities',
    imports: [NgIcon, QpxIcon],
    templateUrl: './capabilities.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'grid items-center gap-2 md:grid-cols-[1fr_auto_1fr]',
        role: 'region',
        'aria-label': 'Publishing inclusions comparison',
    },
})
export class PublishCapabilities {
    public readonly rows = input.required<readonly CapabilityRow[]>();
}
